import React, { useState } from 'react'
import Counter from './counter'
import langTranslate from 'locale'
import TooltipMessage from 'components/Travellers/TooltipMessage'
import classNames from 'classnames'

function Travellers(props) {
    const TOTAL_TRAVELLER_COUNT = 9
    const [clickedItem, setClickedItem] = useState(false)
    const { urlParam, query, setQuery, activeFare } = props
    const shouldDisable = (activeFare === 'student' || activeFare === 'senior_citizen')
    const [travellers, setTravellers] = useState({
        adults: parseInt(urlParam.adults, 10),
        childs: parseInt(urlParam.childs, 10),
        infants: parseInt(urlParam.infants, 10)
    })
    const { adults, childs, infants } = travellers
    const travellerGroup1 = { adults, childs }
    const travellerGroup2 = { infants }
    const totalValueGroup1 = Object.keys(travellerGroup1).reduce((sum, key) => sum + travellerGroup1[key], 0)
    const totalValueGroup2 = Object.keys(travellerGroup2).reduce((sum, key) => sum + travellerGroup2[key], 0)
    const [total, setTotal] = useState(totalValueGroup1 + totalValueGroup2)

    function toggleFn(active) {
        if (active) {
            setClickedItem(null)
        }
    }
    function handleIncrementAdult() {
        setTravellers({
            ...travellers,
            adults: travellers.adults + 1
        })
        setQuery({
            ...query,
            adults: travellers.adults + 1
        })
    }

    function handleDecrementAdult() {
        setTravellers({
            ...travellers,
            adults: travellers.adults - 1,
            infants: travellers.infants >= travellers.adults ? travellers.infants - 1 : travellers.infants
        })

        setQuery({
            ...query,
            adults: travellers.adults - 1,
            infants: travellers.infants >= travellers.adults ? travellers.infants - 1 : travellers.infants
        })
    }

    function handleIncrementChild() {
        setTravellers({
            ...travellers,
            childs: travellers.childs + 1
        })
        setQuery({
            ...query,
            childs: travellers.childs + 1
        })
    }

    function handleDecrementChild() {
        setTravellers({
            ...travellers,
            childs: travellers.childs - 1
        })

        setQuery({
            ...query,
            childs: travellers.childs - 1
        })
    }
    function handleIncrementInfants() {
        setTravellers({
            ...travellers,
            infants: travellers.infants + 1
        })

        setQuery({
            ...query,
            infants: travellers.infants + 1
        })
    }
    function handleDecrementInfants() {
        setTravellers({
            ...travellers,
            infants: travellers.infants - 1
        })

        setQuery({
            ...query,
            infants: travellers.infants - 1
        })
    }
    function updateTraveller() {
        setTotal(totalValueGroup1 + totalValueGroup2)
        setClickedItem('traveller')
        props.onUpdate(travellers)
    }
    return (
        <>
            <div className="ls-reset br-4 w-100p px-2 dropdown__item c-neutral-900 flex flex-between flex-middle px-4">
                <div className="flex flex-column" style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                    <span className="fs-4 fw-500 lh-24 c-inherit">{'Adults'}</span>
                    <span className="fs-2 fw-500 c-neutral-500">({langTranslate('12+ Years')})</span>
                </div>

                <Counter
                    handleSize={20}
                    value={travellers.adults}
                    minValue={1}
                    maxValue={TOTAL_TRAVELLER_COUNT - travellers.childs}
                    onIncrement={handleIncrementAdult}
                    onDecrement={handleDecrementAdult}
                />
            </div>
            <div className={classNames("ls-reset br-4 w-100p px-2 dropdown__item flex flex-between flex-middle px-4",{
                'c-neutral-900': !shouldDisable,
                'c-neutral-200': shouldDisable
            })}>
                { shouldDisable && <TooltipMessage title='Children' sft={activeFare}  width='340px' height='30px' distance={25} right='30px'/>}
                <div className="flex flex-column mt-2 mb-2" style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                    <span className="fs-4 fw-500 lh-24 fs-3 c-inherit">{langTranslate('Children')}</span>
                    <span className={`fs-2 fw-500 ${!shouldDisable ? 'c-neutral-500' : ''}`}>({langTranslate('2 - 12 yrs')})</span>
                </div>

                <Counter
                    handleSize={20}
                    value={travellers.childs}
                    minValue={0}
                    maxValue={shouldDisable ? 0 : TOTAL_TRAVELLER_COUNT - travellers.adults}
                    onIncrement={handleIncrementChild}
                    onDecrement={handleDecrementChild}
                />
            </div>
            <div className={classNames("ls-reset br-4 w-100p px-2 dropdown__item flex flex-between flex-middle px-4",{
                'c-neutral-900': !shouldDisable,
                'c-neutral-200': shouldDisable
            })}>
                { shouldDisable && <TooltipMessage title='Infants' sft={activeFare} width='340px' height='30px' distance={25} right='30px' />}
                <div className="flex flex-column" style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                    <span className="fs-4 fw-500 lh-24 fs-3 c-inherit">{'Infants'}</span>
                    <span className={`fs-2 fw-500 ${!shouldDisable ? 'c-neutral-500' : ''}`}>({langTranslate('Below 2 yrs')})</span>
                </div>

                <Counter
                    handleSize={20}
                    value={travellers.infants}
                    minValue={0}
                    maxValue={shouldDisable ? 0 : travellers.adults}
                    onIncrement={handleIncrementInfants}
                    onDecrement={handleDecrementInfants}
                />
            </div>
        </>
    )
}
export default Travellers
